// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredCategoriesStyles } from "@guestsupply/App/Widgets/FeaturedCategories/FeaturedCategories";
import { ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

featuredCategoriesStyles.centeringWrapper = {
    css: css`
        height: 215px;
        display: flex;
        align-items: center;
    `,
};
featuredCategoriesStyles.spinner = {
    css: css`
        margin: auto;
    `,
};
featuredCategoriesStyles.categoriesWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        gap: 26px 24px;
        flex-wrap: wrap;
    `,
};
featuredCategoriesStyles.categoryWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 246px;
        ${xScreen("lte", "md")} {
            width: 232px;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
featuredCategoriesStyles.imageWrapper = {
    css: css`
        width: 246px;
        height: 98px;
        border-radius: 4px;
        ${xScreen("lte", "md")} {
            width: 232px;
            height: 92px;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            height: 132px;
        }
    `,
};
featuredCategoriesStyles.image = {
    css: css`
        object-fit: cover;
        width: 100%;
        height: auto;
        max-height: 100%;
        border-radius: 4px;
    `,
};
featuredCategoriesStyles.link = {
    color: "text.main",
    typographyProps: {
        size: 14,
        css: css`
            text-align: center;
            margin-bottom: 0;
            margin-top: 12px;
            ${ellipsis(2)};
        `,
    },
};
featuredCategoriesStyles.swiperStyles = {
    container: {
        css: css`
            .xng-pagination-container {
                margin-top: 36px;
                ${xScreen("lte", 767)} {
                    margin-top: 20px;
                }
            }
        `,
    },
};
